import { logAPI } from "./andyliticsApi";
import { debug } from "util";
import * as tools from "../helpers/Tools";


/**
 * Returns an auth token for the given user.
 * 
 * @param {any} payload username & password
 * @returns {any} oauth token
 */
export const userAuthenticate = (payload) => {
    const fullUrl = `${window.serverData.data.ssoBaseURL}OAuth/Token`;
    const start = new Date();

    const params = {
        method: "POST",
        body: JSON.stringify({
            "username": payload.userName,
            "password": payload.password, 
            "grant_type": "password"
        })
    };

    return ssoFetch(fullUrl, params).then(
        function (response) {
            logAPI("MBHWeb.Api.SSO.UserAuthenticate", start, fullUrl);
            
            return response.json();
        }
    ).then(
        function (ret) {
            ret.dateLoaded = new Date(); 
            return ret;
        }
    ).catch(err => { logAPI("MBHWeb.Api.SSO.UserAuthenticate.Failure", start, fullUrl); return Promise.reject(err); });
};


export const userRefresh = (payload) => {
    const fullUrl = `${window.serverData.data.ssoBaseURL}OAuth/Token`;
    const start = new Date();

    const params = {
        method: "POST",
        body: JSON.stringify({
            "refresh_token": payload.refresh_token,
            "grant_type": "refresh_token"
        })
    };

    return ssoFetch(fullUrl, params).then(
        function (response) {
            //debugger;
            logAPI("MBHWeb.Api.SSO.UserRefresh", start, fullUrl);
            return response.json();
        }
    ).then(
        function (ret) {
            //debugger;
            ret.dateLoaded = new Date(); 
            return ret;
        }
    ).catch(err => { logAPI("MBHWeb.Api.SSO.UserRefresh.Failure", start, fullUrl); return Promise.reject(err); });

};

export const userLogout = () => {
    const fullUrl = `${window.serverData.data.ssoBaseURL}Logon/LogoutCurrentUser2`;
    const start = new Date();

    const params = {
        method: "POST",
    };

    return ssoFetch(fullUrl, params).then(
        function (response) {
            //debugger;
            logAPI("MBHWeb.Api.SSO.UserLogout", start, fullUrl);
            return response; // response.json();  // don't really care about the response
        }
    ).then(
        function (ret) {
            //debugger;
            //ret.dateLoaded = new Date();
            return ret;
        }
    ).catch(err => { logAPI("MBHWeb.Api.SSO.UserLogout.Failure", start, fullUrl); return Promise.reject(err); });

};

export const isLoggedInPost2 = (sToken) => {
    //debugger;
    var d = new Date();
    var fullUrl = `${window.serverData.data.ssoBaseURL}logon/IsLoggedInPost2?u=` + d.getTime();
    if (sToken) {
        fullUrl = fullUrl + '&T=' + sToken;  
    }
    const start = new Date();
    //console.log(payload);
    const params = {
        method: "POST",
        body: JSON.stringify({
            "token": null
        }),
    };

    return ssoFetch(fullUrl, params)
        .then(resp => {
            logAPI("MBHWeb.Api.SSO.IsLoggedInPost2", start, fullUrl);
            return resp.json();
        })
        .catch((error) => {
            logAPI("MBHWeb.Api.SSO.IsLoggedInPost2.Failure", start, fullUrl);
            console.log("Failed fetching: " + fullUrl);
            console.log(error);
            throw error;
            //return { IsLoggedIn: false }; // Mission critical... return something
        });

};

export const isLoggedIn = () => {
    //debugger;
    const fullUrl = `${window.serverData.data.ssoBaseURL}logon/isLoggedIn2`;
    const start = new Date();

    return ssoFetch(fullUrl)
        .then(resp => {
            logAPI("MBHWeb.Api.SSO.IsLoggedIn", start, fullUrl);
            return resp.json();
        })
        .catch((error) => {
            logAPI("MBHWeb.Api.SSO.IsLoggedIn.Failure", start, fullUrl);
            return { IsLoggedIn: false }; // Mission critical... return something
        });

};

export const ssoFetch = (url, params) => {
    if (typeof params === "undefined" || params === null) {
        params = {method: "GET"}
    }
    params.headers = params.headers || {};
    params.headers["Accept"] = "application/json";
    params.headers["Content-type"] = "application/json";
    params.headers["Cache-Control"] = "no-cache";
    params.headers["Pragma"] = "no-cache";

    return fetchWithCreds(url, params);
}